import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
import { notImplemented, release, somewhatImplemented, FileLoadingService } from '@awayfl/swf-loader';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: Security
var Security = /** @class */ (function (_super) {
    __extends(Security, _super);
    function Security() {
        return _super.call(this) || this;
    }
    Object.defineProperty(Security, "exactSettings", {
        // static _pageDomain: string;
        get: function () {
            return Security._exactSettings;
        },
        set: function (value) {
            value = !!value;
            Security._exactSettings = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Security, "disableAVM1Loading", {
        get: function () {
            release || notImplemented('public flash.system.Security::get disableAVM1Loading');
            return;
            // return Security._disableAVM1Loading;
        },
        set: function (value) {
            value = !!value;
            release || notImplemented('public flash.system.Security::set disableAVM1Loading');
            return;
            // Security._disableAVM1Loading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Security, "sandboxType", {
        get: function () {
            release || somewhatImplemented('public flash.system.Security::get sandboxType');
            return Security._sandboxType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Security, "pageDomain", {
        get: function () {
            release || somewhatImplemented('public flash.system.Security::get pageDomain');
            // TODO: convert this to proper URI parsing.
            var pageHost = FileLoadingService.resolveUrl('/');
            var parts = pageHost.split('/');
            parts.pop();
            return parts.pop();
        },
        enumerable: true,
        configurable: true
    });
    Security.allowDomain = function () {
        release || somewhatImplemented('public flash.system.Security::static allowDomain ["' +
            Array.prototype.join.call(arguments, '", "') + '"]');
        /*var whitelist: ICrossDomainSWFLoadingWhitelist = this.sec.player;
    for (var i = 0; i < arguments.length; i++) {
      whitelist.addToSWFLoadingWhitelist(axCoerceString(arguments[i]) || '', false, false);
    }*/
    };
    Security.allowInsecureDomain = function () {
        release || somewhatImplemented('public flash.system.Security::static allowInsecureDomain');
        /*var whitelist: ICrossDomainSWFLoadingWhitelist = this.sec.player;
    for (var i = 0; i < arguments.length; i++) {
      whitelist.addToSWFLoadingWhitelist(axCoerceString(arguments[i]) || '', true, false);
    }*/
    };
    Security.loadPolicyFile = function (url) {
        url = axCoerceString(url);
        release || somewhatImplemented('public flash.system.Security::static loadPolicyFile');
    };
    Security.showSettings = function (panel) {
        if (panel === void 0) { panel = 'default'; }
        panel = axCoerceString(panel);
        release || notImplemented('public flash.system.Security::static showSettings');
        return;
    };
    Security.duplicateSandboxBridgeInputArguments = function (toplevel, args) {
        toplevel = toplevel;
        args = args;
        release || notImplemented('public flash.system.Security::static duplicateSandboxBridgeInputArguments');
        return;
    };
    Security.duplicateSandboxBridgeOutputArgument = function (toplevel, arg) {
        toplevel = toplevel;
        release || notImplemented('public flash.system.Security::static duplicateSandboxBridgeOutputArgument');
        return;
    };
    // Called whenever the class is initialized.
    Security.classInitializer = null;
    // List of static symbols to link.
    Security.classSymbols = null; // [];
    // List of instance symbols to link.
    Security.instanceSymbols = null; // [];
    // JS -> AS Bindings
    Security.REMOTE = 'remote';
    Security.LOCAL_WITH_FILE = 'localWithFile';
    Security.LOCAL_WITH_NETWORK = 'localWithNetwork';
    Security.LOCAL_TRUSTED = 'localTrusted';
    Security.APPLICATION = 'application';
    // AS -> JS Bindings
    Security._exactSettings = false;
    // static _disableAVM1Loading: boolean;
    Security._sandboxType = 'remote';
    return Security;
}(ASObject));
export { Security };
